<template>
  <div class="page container">
        
        <Menu></Menu>
      <hr />
    </div>
</template>

<script>
  import Menu from './_menu';

  export default {
    components: {
      Menu
    }
  };
</script>

<style>

</style>